import { render, staticRenderFns } from "./ModalProductCustomization.vue?vue&type=template&id=3424ce2c"
import script from "./ModalProductCustomization.vue?vue&type=script&lang=js"
export * from "./ModalProductCustomization.vue?vue&type=script&lang=js"
import style0 from "./ModalProductCustomization.vue?vue&type=style&index=0&id=3424ce2c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3424ce2c')) {
      api.createRecord('3424ce2c', component.options)
    } else {
      api.reload('3424ce2c', component.options)
    }
    module.hot.accept("./ModalProductCustomization.vue?vue&type=template&id=3424ce2c", function () {
      api.rerender('3424ce2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalProductCustomization.vue"
export default component.exports